import React, { useCallback } from 'react';
import { ServicesContext } from '~/services';
import { defaultApiResponseHandler } from '~/util';

export type TimelyActionMeasureType = {
    code: string;
    short_name: string;
    description: string;
};
export type GetTimelyActionMeasuresReturnType = {
    data: TimelyActionMeasureType[];
};
export const useGetTimelyActionMeasures = () => {
    const services = React.useContext(ServicesContext);

    const getTimelyActionMeasures = useCallback(
        async (options?: ApiRequestOptionsType) => {
            try {
                const result: GetTimelyActionMeasuresReturnType = await services.api.call(
                    {
                        method: 'get',
                        url: '/api/timely-actions/measures',
                    },
                    options
                );
                return result.data;
            } catch (error) {
                throw defaultApiResponseHandler(error);
            }
        },
        [services.api]
    );

    return getTimelyActionMeasures;
};
